import {useMemo} from "react";
import {formatCharacterSenses} from "@/characters/model/CharacterSenses.ts";
import {Action, ActionType, Character} from "@/characters/model/Character.ts";

export interface CharacterDetailRow {
    label: string;
    values: string[];
}

export interface CharacterDetailsViewModel {
    actions: Action[];
    traits: Action[];
    reactions: Action[];
    legendaryActions: Action[];
    detailRows: CharacterDetailRow[];
}

export function useCharacterDetailsViewModel(character: Character): CharacterDetailsViewModel {
    return useMemo(() => {
        const byType = (type: ActionType) => character.actions?.filter(action => action.type === type) ?? [];
        const detailRows = [
            {label: "Skills", values: character.skills},
            {label: "Zustands\u00adimmunitäten", values: character.conditionImmunitys},
            {label: "Schadens\u00adimmunitäten", values: character.damageImmunitys},
            {label: "Resistenzen", values: character.damageResistances},
            {label: "Verwundbarkeit", values: character.damageVulnerabilitys},
            {label: "Sinne", values: formatCharacterSenses(character.senses)},
            {label: "Sprachen", values: character.languages},
        ].filter((row): row is CharacterDetailRow => Boolean(row.values?.length));

        return {
            actions: byType("Action"),
            traits: byType("Trait"),
            reactions: byType("Reaction"),
            legendaryActions: byType("Legendary"),
            detailRows,
        };
    }, [character]);
}
